import { graphql } from '../../../../graphql/generated';

export const CREATE_SPECIMEN_MUTATION = graphql(`
  mutation CreateSpecimen($input: SpecimenCreateInput!) {
    createSpecimen(input: $input) {
      id
    }
  }
`);
